import {useCallback, useMemo} from 'react';
import ExclamationPoint from './exclamation-point.svg?tsx';
import Lock from './lock.svg?tsx';
import styles from './index.module.scss';

/** 空白状态类型 */
export enum EmptyType {
    /** 组件发布后可预览效果 */
    previewComponentAfterPublish,
    /** 正在沟通中 */
    Communicating,
    /** 你的智能创作还未完成 */
    NotDone,
}

/** 空白状态类型到各类型对应数据的映射 */
const EmptyTypeToDataMap: Record<EmptyType, {
    /** 空白状态的 logo 组件 */
    component: React.ElementType;
    /** 空白状态显示的文本。支持占位符功能，例如 $0、$1、$2 */
    text: string;
}> = {
    [EmptyType.previewComponentAfterPublish]: {
        component: ExclamationPoint,
        text: '组件发布后可预览效果',
    },
    [EmptyType.Communicating]: {
        component: Lock,
        text: '$0 正在沟通中',
    },
    [EmptyType.NotDone]: {
        component: ExclamationPoint,
        text: '你的智能创作还未完成',
    },
};

interface IProps {
    /** 空白状态类型 */
    type: EmptyType;
    /** 文本里面的待替换的占位符的参数值 */
    textParams?: string[];
}

export const Empty = (props: IProps) => {
    const {type, textParams} = props;
    const Component = useMemo(() => EmptyTypeToDataMap[type].component, [type]);

    /** 获取文本：将 textParams 替换 text 里面的占位符 */
    const getText = useCallback(() => {
        let targetText = EmptyTypeToDataMap[type].text;
        if (Array.isArray(textParams)) {
            textParams.forEach((value, index) => {
                targetText = targetText.replace(`$${index}`, value);
            });
        }
        return targetText;
    }, [type, textParams]);

    return (
        <div className={styles['empty-container']}>
            <div className={styles['empty-logo']}>
                <Component />
            </div>
            <p className={styles['empty-text']}>
                {getText()}
            </p>
        </div>
    );
};
